import { folderIdDetail } from "./folderIdReducer";

export const folder_id_action = (query) => async (dispatch) => {
    try {
        dispatch(folderIdDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};